//this is here to async load zxcvbn, dramatically reducing bundle size
export async function checkPassword(pw: string): Promise<number> {
  const zxcvbn = await import("zxcvbn");
  return zxcvbn.default(pw).score;
}
